import { render, staticRenderFns } from "./RelatorioLogFuncao.vue?vue&type=template&id=4408e5a6&scoped=true"
import script from "./RelatorioLogFuncao.vue?vue&type=script&lang=js"
export * from "./RelatorioLogFuncao.vue?vue&type=script&lang=js"
import style0 from "./RelatorioLogFuncao.vue?vue&type=style&index=0&id=4408e5a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4408e5a6",
  null
  
)

export default component.exports